import { Edit3, Maximize, Minimize, RotateCcw, ZoomIn, ZoomOut } from 'lucide-react';

interface PanoramaControlsProps {
  isFullscreen: boolean;
  isSplitView: boolean;
  canSplitView: boolean;
  canDraw: boolean;
  canResetView: boolean;
  toggleFullscreen: () => void;
  setIsSplitView: (value: boolean) => void;
  setCameraToNextPosition: () => void;
  onZoomIn: () => void;
  onZoomOut: () => void;
  isDrawingMode: boolean;
  toggleDrawingMode: () => void;
}

const PanoramaControls = ({
  isFullscreen,
  isSplitView,
  canSplitView,
  canDraw,
  canResetView,
  toggleFullscreen,
  setIsSplitView,
  setCameraToNextPosition,
  onZoomIn,
  onZoomOut,
  isDrawingMode,
  toggleDrawingMode,
}: PanoramaControlsProps) => {
  const canFullscreen =
    !!document.documentElement.requestFullscreen ||
    !!(document.documentElement as any).webkitRequestFullscreen;

  return (
    <>
      <div className="absolute top-4 right-4 flex gap-2 z-20">
        {canResetView && (
          <button
            onClick={setCameraToNextPosition}
            className="bg-black bg-opacity-75 hover:bg-opacity-90 text-white p-2 rounded-lg transition-opacity"
            title="Ansicht zurücksetzen"
          >
            <RotateCcw size={20} />
          </button>
        )}
        {canSplitView && (
          <button
            onClick={() => setIsSplitView(!isSplitView)}
            className={`bg-black bg-opacity-75 hover:bg-opacity-90 text-white p-2 rounded-lg transition-opacity${isDrawingMode ? ' opacity-50 cursor-not-allowed' : ''}`}
            title={isSplitView ? "Split View ausschalten" : "Split View einschalten"}
            disabled={isDrawingMode}
          >
            <div className="flex items-center">
              <div className="w-2 h-3 bg-white mr-0.5"></div>
              <div className="w-2 h-3 bg-white ml-0.5"></div>
            </div>
          </button>
        )}
        {canDraw && (
          <button
            onClick={toggleDrawingMode}
            disabled={isSplitView}
            className={`p-2 rounded-lg transition-opacity ${isDrawingMode
              ? 'bg-blue-500 bg-opacity-75 hover:bg-opacity-90 text-white'
              : `bg-black bg-opacity-75 hover:bg-opacity-90 text-white ${isSplitView ? 'opacity-50 cursor-not-allowed' : ''}`
              }`}
            title={isDrawingMode ? "Zeichnen beenden" : "Rechtecke zeichnen"}
          >
            <Edit3 size={20} />
          </button>
        )}
        {canFullscreen && (
          <button
            onClick={toggleFullscreen}
            className="bg-black bg-opacity-75 hover:bg-opacity-90 text-white p-2 rounded-lg transition-opacity"
            title={isFullscreen ? "Vollbild verlassen" : "Vollbild"}
          >
            {isFullscreen ? <Minimize size={20} /> : <Maximize size={20} />}
          </button>
        )}
      </div>

      {/* Zoom controls - bottom right */}
      <div className="absolute bottom-4 right-4 flex flex-col gap-2 z-20">
        <button
          onClick={onZoomIn}
          className="bg-black bg-opacity-75 hover:bg-opacity-90 text-white p-2 rounded-lg transition-opacity"
          title="Hineinzoomen"
        >
          <ZoomIn size={20} />
        </button>
        <button
          onClick={onZoomOut}
          className="bg-black bg-opacity-75 hover:bg-opacity-90 text-white p-2 rounded-lg transition-opacity"
          title="Herauszoomen"
        >
          <ZoomOut size={20} />
        </button>
      </div>
    </>
  );
};

export default PanoramaControls;
